<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h1 class="mb-4 menu-dark font-weight-light">Loading...</h1>

      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'GuestAuth',
  data() {
    return  {}
  },
  methods: {
    loadData () {
      let token = this.$route.query.token;
      let email = this.$route.query.email;

      console.log('token: ', token)
      console.log('email: ', email)
      console.log('here')
      if (token) {

        axios.get('/chipin/account/auth/guest/?token=' + token + '&email=' + email)
            .then(res => {
              console.log('here 1')
              token = res.data.token
              localStorage.setItem('accessToken', token)
              this.$store.dispatch('storeToken', token)
              this.$router.replace('/')
            })
            .catch(error => {
              console.log('here 2')
              console.log(error)
              this.name = 'Sorry something went wrong!';
              console.log(error)
            });

      } else {
        console.log('here 3')
        this.name = 'Sorry something went wrong!';
      }

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>
